import { render, staticRenderFns } from "./ProvidersExpertiseChips.vue?vue&type=template&id=7c59c672&scoped=true"
import script from "./ProvidersExpertiseChips.vue?vue&type=script&lang=js"
export * from "./ProvidersExpertiseChips.vue?vue&type=script&lang=js"
import style0 from "./ProvidersExpertiseChips.vue?vue&type=style&index=0&id=7c59c672&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c59c672",
  null
  
)

export default component.exports